import * as form from '../form';

export const relationshipsMarital = (data = {}) => {
  const items = ((data?.DivorcedList || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        Name: form.name(xitem.Name),
        Birthdate: form.datecontrol(xitem.Birthdate),
        BirthPlace: form.location(xitem.BirthPlace),
        Citizenship: form.country(xitem.Citizenship),
        Telephone: form.telephone(xitem.Telephone),
        Recognized: form.datecontrol(xitem.Recognized),
        Address: form.location(xitem.Address),
        MarriageLocation: form.location(xitem.MarriageLocation),
        DateDivorced: form.datecontrol(xitem.DateDivorced),
        DivorceLocation: form.location(xitem.DivorceLocation),
        DivorceLocationNotApplicable: form.notapplicable(xitem.DivorceLocationNotApplicable),
        Status: form.radio(xitem.Status),
        Deceased: form.radio(xitem.Deceased),
        DeceasedAddress: form.location(xitem.DeceasedAddress),
        DeceasedDate: form.datecontrol(xitem.DeceasedDate),
        DeceasedAddressNotApplicable: form.notapplicable(xitem.DeceasedAddressNotApplicable),
        Comments: form.textarea(xitem.Comments),
        DivorcedAnnulledComments: form.textarea(xitem.DivorcedAnnulledComments),
        DivorcedAnnulledComments2: form.textarea(xitem.DivorcedAnnulledComments2),
        Emails: form.collection(form.emailCollection(xitem.Emails)), // pvq
      },
    };
  });
  return {
    Status: form.radio(data?.Status),
    CivilUnion: form.civilunion(data?.CivilUnion),
    DivorcedList: form.collection(items, (data?.DivorcedList || {}).branch),
    DivorcedSummaryComments: form.textarea(data?.DivorcedSummaryComments),
    DivorcedComments: form.textarea(data?.DivorcedComments),
  };
};
